/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtexttoolbar2Inputs */

const en_richtexttoolbar2 = /** @type {(inputs: Richtexttoolbar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting`)
};

const de_richtexttoolbar2 = /** @type {(inputs: Richtexttoolbar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung`)
};

/**
* | output |
* | --- |
* | "Formatting" |
*
* @param {Richtexttoolbar2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtexttoolbar2 = /** @type {((inputs?: Richtexttoolbar2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtexttoolbar2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtexttoolbar2(inputs)
	return de_richtexttoolbar2(inputs)
});
export { richtexttoolbar2 as "richTextToolbar" }